export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./root-layout.vue?vue&type=template&id=08d434ef"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/root-layout.vue?vue&type=template&id=08d434ef
// module id = j6j1
// module chunks = 0